import React from 'react'

export default class IrPreview extends React.Component {
  componentWillMount() {
    const { map, addToMarkers } = this.props
    this.line = new google.maps.Polyline({
      map: map,
      path: [],
      strokeColor: 'red',
      strokeOpacity: 1,
      strokeWeight: 3,
      zIndex: 102,
      visible: false
    })
    addToMarkers('irLine', this.line)
  }

  pathForIrLine(props) {
    const { cameraMarkerPosition, heading, model } = props
    if (this.shouldDisplay(props)) {
      const position = google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, model.infrared, heading)
      return [cameraMarkerPosition, position]
    } else {
      return []
    }
  }

  shouldDisplay(props) {
    const { model, displayIrLine } = props
    return displayIrLine && model && model.infrared > 0
  }

  componentWillReceiveProps(nextProps) {
    const { line } = this
    if (this.shouldDisplay(nextProps)) {
      line.setVisible(true)
      line.setPath(this.pathForIrLine(nextProps))
    } else {
      line.setVisible(false)
    }
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/IrPreview.js